exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cancelled-content[data-v-1bacf79d] {\n  margin: auto;\n  text-align: center;\n}\n.title[data-v-1bacf79d] {\n  font-size: 20px;\n}\n.subtitle[data-v-1bacf79d] {\n  margin-top: 15px;\n  margin-bottom: 42px;\n}\n", ""]);

// exports
